import { useUserRole } from "@/hooks/useMarketplace";

/**
 * Server-validated admin check. Resolves the current user's roles from the
 * `user_roles` table (RLS-protected) and returns true only when the `admin`
 * role is present. Never rely on client-side email comparisons.
 */
export const useIsAdmin = (): boolean => {
  const { data: roles } = useUserRole();
  return Array.isArray(roles) && roles.includes("admin");
};